import React from "react";
import { FormItemBigRadio } from "../../../../components/form-item/form-item-big-radio/form-item-big-radio";
import generatorForm from "../../generator-form";
export var PrintForm = function (_a) {
    var tooltips = _a.tooltips;
    var cropMarks = generatorForm.cropMarks;
    return (React.createElement("div", { className: "print-form" },
        React.createElement("div", { className: "print-form__container" },
            React.createElement(FormItemBigRadio, { name: cropMarks.name, label: cropMarks.label, options: [
                    { label: "Ano", value: "yes" },
                    { label: "Ne", value: "no" },
                ], tooltips: tooltips }))));
};
